import { render, staticRenderFns } from "./EditClassification.vue?vue&type=template&id=32a88d34&scoped=true"
import script from "./EditClassification.vue?vue&type=script&lang=js"
export * from "./EditClassification.vue?vue&type=script&lang=js"
import style0 from "./EditClassification.vue?vue&type=style&index=0&id=32a88d34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a88d34",
  null
  
)

export default component.exports